import * as React from "react";

import { BottomSheet } from "../BottomSheet";
import { CustomButton } from "../Button";

import { PickerField } from "./PickerField";
import { WheelPicker } from "./WheelPicker";

export const WheelInputField: React.FC<{
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  values?: number[];
  unit?: string;
  initialValue?: number;
}> = ({
  label,
  value,
  onChange,
  onBlur,
  error,
  values = Array.from({ length: 21 }, (_, n) => n),
  unit = "件",
  initialValue = 0,
}) => {
  const [open, setOpen] = React.useState(false);
  const [draft, setDraft] = React.useState<number>(0);
  const close = () => {
    setOpen(false);
    onBlur?.();
  };
  return (
    <>
      <PickerField
        label={label}
        value={value}
        onChange={onChange}
        options={values.map((n) => ({ value: String(n), label: `${n}${unit}` }))}
        error={error}
        onBlur={onBlur}
        openPicker={() => {
          setDraft(value ? Number(value) : initialValue);
          setOpen(true);
        }}
      />
      <BottomSheet
        open={open}
        title={label}
        onOpen={() => setOpen(true)}
        onClose={close}
        maxHeightPercent={70}
        footer={
          <CustomButton
            buttonSize="L"
            type="button"
            onClick={() => {
              onChange(String(draft));
              close();
            }}
          >
            決定
          </CustomButton>
        }
      >
        <WheelPicker
          columns={[{ label, values, value: draft, initialValue, unit, onChange: setDraft }]}
          echo={`${draft}${unit}`}
        />
      </BottomSheet>
    </>
  );
};
